import type { FaireProductEntity } from "../../entity_types/product";

export const p_uxpdx9rb2w: FaireProductEntity = {
  token: "p_uxpdx9rb2w",
  type: "product",
  name: "Chain Fringe 18K Gold Plated S.Steel Hoop Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/89b649df9674db408f3fffed8a184c10a1b1fd96fd63a9fd9783e4622ae0ab60.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d169c7fc64c9f4ee35264ff407ba4abe2cd19798d88b73641a29ff7c2763b1a.jpeg",
    "https://cdn.faire.com/fastly/a39901222103e399d5e5631965d58d367e1f13525560d946fc1fa09a35bd605a.jpeg",
    "https://cdn.faire.com/fastly/cde0f7f8c98d4bfe98f5ae2c891a95e42605aa4ac79aa4b7aadcd1ed062aed31.jpeg",
    "https://cdn.faire.com/fastly/568996097780625b1898c06dcec0ff0ef504a12e1f913dc6bee64fb2d3078e7e.jpeg",
    "https://cdn.faire.com/fastly/d1215ea956bbd63eb3685854e2a265a70e5bc98d4e004c94a93c3fee4cdd344e.jpeg",
  ],
  priceDollars: 8.13,
  description:
    "Type: Earrings\nMaterial : Stainless steel ,18K gold plated\nSize :23mm*55mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts   ",
  tags: [],
  msrpDollars: 20.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:27.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
